// extracted by mini-css-extract-plugin
export var actionButton = "_ig-0";
export var fileInput = "_ig-2";
export var paperclip = "_ig-1";